module.exports = __webpack_public_path__ + "static/img/code.5106b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code.png
// module id = EF7e
// module chunks = 0